import axios from "axios";
import config from "../config";
import { getDeviceInfo } from "../utils/editorUtils/editorUtils";
export const unifiedPageUrl = config.unifiedPageUrl;
export const WEB_URL = `${config.webUrl}/`;
export const moduleApiEndPoint = `${config.apiHost}/api/v1/`;
export const moduleApiEndPointV2 = `${config.apiHost}/api/v2/`;
export const PreviewEndPoint = `${config.apiHost}/`;

export const instance = axios.create({
  baseURL: moduleApiEndPoint,
  timeout: 120000,
});

// Add a request interceptor
instance.interceptors.request.use(
  function (config) {
    const token = window.localStorage.getItem("userToken");
    
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
      config.headers["device-info"] = getDeviceInfo();
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// Add a response interceptor
instance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    return Promise.reject(error);
  }
);
export const instanceStorage = axios.create({
  baseURL: moduleApiEndPoint,
  timeout: 8000,
  // headers: { "X-Custom-Header": "foobar" },
});

// Add a request interceptor
instanceStorage.interceptors.request.use(
  function (config) {
    const token = window.localStorage.getItem("userToken");
    
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// Add a response interceptor
instanceStorage.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    return Promise.reject(error);
  }
);

export const instanceUpload = axios.create({
  baseURL: moduleApiEndPoint,
  timeout: 60 * 4 * 1000,
  headers: {
    "Cache-Control": "no-cache",
    Pragma: "no-cache",
    Expires: "0",
  },
});

// Add a request interceptor
instanceUpload.interceptors.request.use(
  function (config) {
    const token = window.localStorage.getItem("userToken");
    
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// Add a response interceptor
instanceStorage.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// export default instance;

export default instance;
